<template>
  <div v-show="value" ref="dialog" class="act_alert_dialog">
    <img
      src="https://vipcdn.mgtv.com/lego/20211223/lego/2b1038bc63d811ecbe25005056921140.png"
      class="close"
      @click="handleAction('cancel')"
    />

    <div class="content">
      <div class="h1">优惠券领取</div>
      <div class="gz" @click="showGz">使用说明</div>
      <div v-html="title" v-if="title" class="title"></div>
      <div class="input">
        <input class="mobile" placeholder="请输入手机号码" type="text" v-model="mobile" />
      </div>
      <!-- <div class="select-wrap">
        <select v-model="selected" class="mobile">
          <option disabled value="">请选择</option>
          <option v-for="(item, index) in mCityArr" :key="index" :value="item">{{ item }}</option>
        </select>
      </div> -->
      <div class="submit" @click.prevent="handleAction('confirm')" v-if="button">{{ button }}</div>
    </div>
  </div>
</template>
<script>
import { createNamespace, isDef } from 'vant/lib/utils';
import { PopupMixin } from 'vant/lib/mixins/popup';
const [createComponent, bem] = createNamespace('popup');

import { setStyle } from '../../../tools/dom';
import click_handler from '../../../tools/mgtv/click';
import {is_mobile} from '../../../tools/validate'

const cityArr = ['MCITY上海魔都station', 'MCITY长沙店']
export default createComponent({
  name: 'ActMcityDialog',
  mixins: [PopupMixin],
  props: {
    callback: Function,
    overlay: {
      type: Boolean,
      default: true
    },
    closeOnClickOverlay: {
      type: Boolean,
      default: false
    },
    lockOnScroll: {
      type: Boolean,
      default: true
    },
    title: {
      type: String,
      default: `<p>规则</p><p>规则</p>`
    },
    button: {
      type: String,
      default: '确认'
    },
    yuyueMobile: {
      type: String,
      default: ''
    },
    yuyueCity: {
      type: String,
      default: ''
    },
    onlyCs: {
      type: Boolean,
      default: false
    }
  },
  data: function() {
    return {
      agreeState: false,
      selected: '',
      mobile: '',
      mCityArr: cityArr,
    };
  },
  methods: {
    handleAction(action) {
      if ((action == 'confirm')) {
        if (!is_mobile(this.mobile)) {
          window.$toast('请输入正确的手机号码');
          return;
        }
        // if (!this.selected) {
        //   window.$toast('请选择门店');
        //   return;
        // }
      }

      this.$emit('input', false);
      this.$emit(action);
      this.callback &&
        this.callback(action, [
          { label: '手机', type: 'tel', value: this.mobile }
          // { label: '门店', type: 'text', value: this.selected }
        ]);
    },
    showGz() {
      click_handler('展示MCITY规则', () => {
        window.$act_alert_dialog.show({
          title: `<div style="max-height:6rem;overflow:auto"><div style="text-align:center;margin-bottom:0.3rem">使用说明</div><p>1、新、老用户均可领取，每个会员每月限领一次；用户需手动填写手机号进行领取，领券后，芒果MCITY会在1个工作日内将优惠券以短信方式发给用户；若您填写错误或未填写手机号，平台将默认视为用户放弃该项权益，平台方不承担赔偿/补偿责任。</p >
                    <p>2、用户在收到优惠券后请前往芒果MCITY小程序进行相关查询及预约；</p >
                    <p>3、查看权益：微信搜索“芒果MCITY”公众号-点击立即预约-长沙店预约通道/或上海入口-手机号码登录-点击“我的”-点击优惠券即可查看权益</p >
                    <p>4、预约流程：微信搜索“芒果MCITY”公众号-立即预约-手机号码登录-选择门店-选择主题、时间、场次-支付时选相应优惠券</p >
                    <p>5、预约过程中需要拼场或遇到其他问题可联系MCITY客服小M，长沙店：17708496118；上海店：15386470058；南京店18905188715 </p >
                    <p>6、优惠券兑换领取后6个月内有效，过期视为自动放弃会员权益；</p >
                    <p>7、本券不兑现、不找零、不与其他优惠同享；</p >
                    <p>8、本券仅限一人使用；</p >
                    <p>9、元旦、春节、劳动节、端午节、国庆节、清明节、中秋节、情人节、圣诞节不可用</p >
                    <p>10、最终解释权归MCITY所有。</p ></div>`,
          button: '我知道了'
        });
      });
    },
    agreeGz() {
      click_handler(`${this.agreeState ? '未同意规则' : '同意规则'}`, () => {
        this.agreeState = !this.agreeState;
      });
    }
  },
  mounted() {},
  watch: {
    value(val){
      if(val){
        if(this.onlyCs){  //只展示长沙门店
          this.selected = 'MCITY长沙店'
          this.mCityArr = ['MCITY长沙店']
        }
        if(this.yuyueMobile){
          this.selected = this.yuyueCity
          this.mobile = this.yuyueMobile
        }
      }else{
        this.selected = ''
        this.mCityArr = cityArr
        this.mobile = ''
      }
    }
  },
  computed: {}
});
</script>

<style lang="stylus" scoped>
@import "../../../share/mixins.styl"

.act_alert_dialog
  padding 0.4rem .3rem .5rem .3rem
  background white
  center()
  border-radius 0.32rem
  color #717171
  position fixed !important

.close
  position absolute
  top 0rem
  right 0
  width .54rem
  height .54rem
  z-index 2
  box-sizing content-box
  padding .2rem


.content
  overflow hidden
  position relative
  width: 6rem
  text-align: center
  font-size: 0.28rem
  line-height: 0.4rem
  color: #333333;
  font-weight: 400;
  .h1
    text-align: center
    height: 0.48rem;
    font-size: 0.36rem;
    font-weight: 600;
    color: #333333;
    line-height: 0.48rem;
    margin-bottom: 0.2rem
  .mobile
    width: 5.2rem;
    height: 0.8rem;
    background: #F6F6F6;
    border-radius: 0.16rem;
    display: block;
    margin: 0.2rem auto;
    padding-left: 0.24rem
    line-height: 0.8rem
    color: #111111
    border: none
  .title
    width 100%
    text-align center
    font-size .4rem
    margin-bottom .4rem
    width: 5.2rem;
    font-size: 0.28rem;
    font-weight: 400;
    color: #333333;
    line-height: 0.4rem;
    text-align: center
    margin: auto
  .submit
    background-size cover
    width: 5.2rem;
    height: 0.88rem;
    background: #FF5F00;
    height .84rem
    text-align center
    color white
    margin .4rem auto 0 auto
    font-size .3rem
    padding-top .16rem
    border-radius: 0.5rem
    line-height: 0.54rem
    font-size: 0.32rem
  .gz
    height: 0.44rem;
    font-size: 0.24rem;
    color: #333333;
    line-height: 0.44rem;
    margin-top: 0.32rem;
    text-align: left
    position: absolute
    right: 0.9rem
    top: -0.26rem
    text-decoration: underline
    span
      display: inline-block
      vertical-align: middle
      em
        font-style: normal
    .select-icon
      width: 0.32rem
      height: 0.32rem
      background-image: url('https://vipcdn.mgtv.com/lego/20211223/lego/6153755c63eb11ecbd3d005056921140.png')
      background-size: contain;
      background-repeat: no-repeat;
      margin-right: 0.08rem
      &.active
        background-image: url('https://vipcdn.mgtv.com/lego/20211223/lego/7d53ce3263eb11ec9055005056921140.png')

.inline-block
  display inline-block
</style>
